(function () {
  'use strict';

  angular.module('MktzapApp.Factories')
    .factory('ChatService', ChatService);

  ChatService.$inject = ['$resource'];

	 function ChatService ($resource) {
    return $resource(apiUrl + '/webchat-config/:id', { id: '@id' }, {
      all: { url: apiUrl + '/webchat-config-all', method: 'GET', params: {}, isArray: true },
      create: { method: 'POST', params: {}, isArray: false },
      delete: { method: 'DELETE', params: {}, isArray: false },
      update: { method: 'POST', params: { _method: 'PATCH' }, isArray: false },
      find: { method: 'GET', params: {}, isArray: false },
      findOne: { method: 'GET', params: {}, isArray: true }
    });
  }
})();
